<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="EditPmm" :validation-schema="PmmSchema">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane"
              type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Information générale</button>
          </li>
          <!-- <li class="nav-item" role="presentation">
            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane"
              type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Méta data</button>
          </li> -->
        </ul>
        <div class="tab-content" id="myTabContent ">
          <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Organes <span class="text-danger">*</span>
                  </label>
                  <Field name="organes" v-slot="{ field }">
                    <Multiselect :options="organesOptions" :searchable="true" multiple="false" data-mode="organes"
                      track-by="value" label="label" v-model="formData.organe" v-bind="field"
                      placeholder="Sélectionner l'organe" @change="onOrganeChange" />
                  </Field>
                  <ErrorMessage name="organes" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Mandatures <span class="text-danger">*</span>
                  </label>
                  <Field name="mandatures" v-slot="{ field }">
                    <Multiselect :options="mandaturesOptions" :searchable="true" multiple="false" data-mode="mandatures"
                      track-by="label" label="label" v-model="formData.mandature" v-bind="field"
                      placeholder="Sélectionner la mandature" />
                  </Field>
                  <ErrorMessage name="mandatures" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Postes <span class="text-danger">*</span>
                  </label>
                  <Field name="postes" v-slot="{ field }">
                    <Multiselect :options="PosteSelected" :searchable="true" multiple="false" data-mode="postes"
                      track-by="label" label="label" v-model="formData.poste" v-bind="field"
                      placeholder="Sélectionner un poste" />
                  </Field>
                  <ErrorMessage name="postes" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="d-flex justify-content-between align-items-center mb-0">
                    <label class="d-block text-black fw-semibold mb-0">
                      Membres <span class="text-danger">*</span>
                    </label>
                    <button type="button" class="btn btn-sm btn-warning mb-1" style="color:white;font-size:10px;"
                      data-bs-toggle="modal" data-bs-target="#addMembreModal">
                      Ajouter +
                    </button>
                  </div>
                  <Field name="membre" v-slot="{ field }">
                    <Multiselect :options="membresOptions" :searchable="true" v-bind="field" :multiple="false"
                      data-mode="membres" track-by="value" label="label" v-model="formData.membre"
                      placeholder="Sélectionner un membre" />
                  </Field>
                  <ErrorMessage name="membre" class="text-danger" />
                </div>
              </div>

              <!--Modal d'ajout de membre -->
              <div class="modal fade" id="addMembreModal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="max-width: 600px;">
                  <div class="modal-content">
                    <div class="modal-header justify-content-center text-center border-0">
                      <h5 class="modal-title" style="text-decoration: underline;">Ajouter un nouveau membre</h5>
                    </div>
                    <div class="modal-body">
                      <div class="row justify-content-center">
                        <div class="col-md-8 mb-3">
                          <label class="form-label">Nom :</label>
                          <input type="text" class="form-control" v-model="newMembre.nom" placeholder="Entrez le nom" />
                        </div>
                        <div class="col-md-8 mb-3">
                          <label class="form-label">Prénom :</label>
                          <input type="text" class="form-control" v-model="newMembre.prenom"
                            placeholder="Entrez le prénom" />
                        </div>
                        <div class="col-md-8 mb-3">
                          <label class="form-label">Image :</label>
                          <input type="file" class="form-control" @change="onNewImageChange" />
                        </div>
                      </div>
                      <div class="modal-footer justify-content-center">
                        <button type="button" class="btn btn-primary" @click="addNewMembre">Ajouter</button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium 
                  text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Modifier
              </button>
              <router-link to="/liste-assignation" class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                  class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>

      </Form>

    </div>

  </div>
</template>


<script lang="ts">
import { defineComponent, ref, reactive, computed, onMounted, nextTick } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import { success, error } from "../../utils/utils";
import { PostMembreMandature } from "@/models/postemembremandature";
import { Membre } from "@/models/postemembremandature";
import { Mandature } from "@/models/postemembremandature";
import { Postes } from "@/models/postemembremandature";
import { Organes } from "@/models/Postes";
import Swal from 'sweetalert2'
import { Modal } from "bootstrap";


export default defineComponent({
  name: "EditAssignation",
  components: { Form, Field, ErrorMessage, Multiselect },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const postemembremandatureId = Number(route.params.id);
    const newMembre = reactive({
      id: "",
      nom: "",
      prenom: "",
      urlImage: null as File | null
    });

    const onNewImageChange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        newMembre.urlImage = target.files[0];
      } else {
        newMembre.urlImage = null;
      }
       
    };
    // Validation schema
    const PmmSchema = Yup.object().shape({
      // organes: Yup.mixed().required("L'organe est obligatoire"),
      // postes: Yup.mixed().required("Le poste est obligatoire"),
      // membre: Yup.mixed().required("Le membre est obligatoire"),
      // mandatures: Yup.mixed().required("La mandature est obligatoire"),
    });

    // Références
    const organesOptions = ref<{ value: number; label: string; postes: Postes[] }[]>([]);
    const mandaturesOptions = ref<{ value: number; label: string }[]>([]);
    const membresOptions = ref<{ value: number; label: string }[]>([]);
    const selectedOrgane = ref<number | null>(null);
    const PosteSelected = ref<{ value: number; label: string }[]>([]);

    // Données du formulaire
    const formData = reactive({
      organe: null as number | null,
      poste: null as number | null,
      membre: null as number | null,
      mandature: null as number | null,
    });

  const addNewMembre = () => {
  if (!newMembre.nom || !newMembre.prenom) {
    Swal.fire({
      title: "Remplissez les champs",
      icon: "error",
      timer: 1500
    });
    return;
  }

  const membreTemp = {
    value: -newMembre.id, 
    label: `${newMembre.nom} ${newMembre.prenom}`
  };

  // On ajoute le membre dans la liste
  membresOptions.value.push(membreTemp);

  // On sélectionne automatiquement ce membre
  formData.membre = membreTemp.value;

  

  // Fermer le modal correctement
  const modalEl = document.getElementById('addMembreModal');
  if (modalEl) {
    const modalInstance = Modal.getInstance(modalEl) || new Modal(modalEl);
    modalInstance.hide();
  }

  Swal.fire({
    title: "Membre ajouté temporairement",
    icon: "success",
    timer: 1500
  });

};

    // Récupérer les organes
    const fetchOrganes = async () => {
      try {
        const response = await ApiService.get('/organes?limit=0');
        organesOptions.value = response.data.data.map((organe: Organes) => ({
          value: organe.id,
          label: organe.nom,
          postes: organe.postes || [],
        }));
      } catch (err) {
        error("Erreur lors du chargement des organes");
      }
    };

    // Récupérer les mandatures
    const fetchMandatures = async () => {
      try {
        const response = await ApiService.get('/mandature');
        mandaturesOptions.value = response.data.data.data.map((mandature: Mandature) => ({
          value: mandature.id,
          label: mandature.libelle,
        }));
      } catch (err) {
        error("Erreur lors du chargement des mandatures");
      }
    };

    // Récupérer les membres
    const fetchMembres = async () => {
      try {
        const response = await ApiService.get('/membre');
        membresOptions.value = response.data.map((membre: Membre) => ({
          value: membre.id,
          label: `${membre.nom} ${membre.prenom}`,
        }));
      } catch (err) {
        error("Erreur lors du chargement des membres");
      }
    };

    // Récupérer les données de l'assignation
    const fetchPmm = async () => {
      try {
        const { data } = await ApiService.get(`/pmm/${postemembremandatureId}`);
        const pmm: PostMembreMandature = data.data;

        // Trouver l'organe correspondant au poste
        const organe = organesOptions.value.find(o =>
          o.postes.some(p => p.id === pmm.poste.id)
        );

        if (organe) {
          //  On définit l’organe d’abord
          selectedOrgane.value = organe.value;
          formData.organe = organe.value;

          //On peuple la liste des postes disponibles pour cet organe
          PosteSelected.value = organe.postes.map((poste: Postes) => ({
            value: poste.id,
            label: poste.nomPoste,
          }));

          //On attend le prochain "tick" (mise à jour DOM/vue)
          await nextTick();

          //Maintenant on définit le poste (il sera trouvé dans les options)
          formData.poste = pmm.poste.id;
        }
       
        formData.membre = pmm.membre.id;
        formData.mandature = pmm.mandature.id;
        
      } catch (err) {
        error("Erreur lors du chargement de l'assignation");
      }
    };


    // Mettre à jour les postes lorsqu'un organe est sélectionné
    const onOrganeChange = (organeId: number) => {
      const selected = organesOptions.value.find(o => o.value === organeId);
      selectedOrgane.value = organeId;
      formData.organe = organeId;
      formData.poste = null; // Réinitialiser le poste
      PosteSelected.value = selected ? selected.postes.map((poste: Postes) => ({
        value: poste.id,
        label: poste.nomPoste || poste.nomPoste,
      })) : [];
    };

    // Soumettre le formulaire
    const EditPmm = async (values: any) => {
  console.log(" Soumission du formulaire", values);

  try {
    let payload: any = {
      posteId: formData.poste,
      mandatureId: formData.mandature,
    };

    //  Si le membre est déjà existant
    if (formData.membre && formData.membre > 0) {
      payload.membreId = formData.membre;
    } 
    // Si c’est un membre temporaire, on envoie l’objet nouveauMembre
    else {
      payload.nouveauMembre = {
        nom: newMembre.nom,
        prenom: newMembre.prenom,
        urlImage: newMembre.urlImage ? newMembre.urlImage.name : null,
      };
    }

    const { data } = await ApiService.put(`/pmm/${postemembremandatureId}`, payload);

    Swal.fire({
      title: "Modification effectuée avec succès",
      icon: "success",
    });
    router.push("/liste-assignation");
  } catch (err) {
    console.error(err);
    error("Erreur lors de la modification");
  }
};


    // Charger les données au montage
    onMounted(async () => {
      await Promise.all([fetchOrganes(), fetchMandatures(), fetchMembres()]);
      await fetchPmm();
    });

    return {
      PmmSchema,
      organesOptions,
      mandaturesOptions,
      membresOptions,
      selectedOrgane,
      PosteSelected,
      formData,
      EditPmm,
      onOrganeChange,
      onNewImageChange,
      addNewMembre,
      newMembre
    };
  },
});
</script>
